module.exports = __webpack_public_path__ + "static/img/14000061.93831c98.png";